import { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { FlexBox, Dropdown, DropdownListItem, Fonts } from '@brg/ui';
import { LayoutConst } from 'core';
import { useTranslation } from 'react-i18next';
import { NeutralLink } from 'shared/components/link/styles';
import { AppTester } from 'supporting';

export interface NavbarLoginWidgetTheming {
  loginButtonColor: string;
  loginButtonHoverColor: string;

  noAvatarBackgroundColor: string;
  noAvatarTextColor: string;

  lang?: string;
}

export const LoginButton = styled(FlexBox)<NavbarLoginWidgetTheming>`
  ${Fonts.Inter.textBold};
  color: ${(p: NavbarLoginWidgetTheming) => p.loginButtonColor};
  transition: all 0.2s;
  align-items: center;
  font-size: 17px !important;
  cursor: pointer;
  line-height: 22px;
  font-weight: 600 !important;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px !important;
    line-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    font-size: 13px !important;
    line-height: 18px;
  }

  &:hover {
    color: ${(p: NavbarLoginWidgetTheming) => p.loginButtonHoverColor};
  }
`;

export const NavbarLoginWidgetOutter = styled(FlexBox)`
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const NavbarLoginAvatarWrapper = styled(FlexBox)<{
  theming: NavbarLoginWidgetTheming;
  url?: string;
}>`
  width: 32px;
  height: 32px;
  justify-items: center;
  align-items: center;
  text-align: center;
  border-radius: 3px;

  background-color: ${(p) => p.theming.noAvatarBackgroundColor};
  color: ${(p) => p.theming.noAvatarTextColor};
  ${(p: any) =>
          p.url
                  ? css`
                    background-image: url('${p.url}') !important;
                    background-position: center center;
                    background-size: cover;
                  `
                  : null};
  @media (max-width: 940px) {
    width: 32px;
    height: 32px;
  }
`;
export const NavbarLoginAvatarText = styled.div`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  width: 100%;
  font-size: 14px;

  @media (max-width: ${LayoutConst.screen.l_16}px){
    font-size: 0.7vw;
  }

  // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  //   font-size: 1vw;
  // }
`;

export const NavbarLoginChangeWrapper = styled(FlexBox)`
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(p) => p.theme.navigationBar.profile.bg};
  flex-direction: column;
`;

export const NavbarLoginChangeFrame = styled(FlexBox)`
  height: 272px;
  overflow-y: auto;
  margin-top: 28px;
  flex-direction: column;
  width: 574px;
`;

export const NavbarLoginChangeRow = styled(FlexBox)`
  cursor: pointer;

  :hover {
    opacity: 0.6;
  }
`;

export interface NavbarLoginUser {
  letters: string;
  avatarUrl?: string;
  profileId?: string;
  name?: string;
}

interface LinkObject {
  path?: string;
  external?: boolean;
}

export interface LoginDropdownItem {
  title: string,
  action?: () => void;
  link?: LinkObject;
  hide?: boolean;
}

export interface NavbarLoginWidgetProps {
  theming: NavbarLoginWidgetTheming;
  user?: NavbarLoginUser;
  loginAction?: () => void;
  logoutAction?: () => void;
  loginButtonText: string;
  dropdown: LoginDropdownItem[];
  className?: any;
}

export const NavbarProfileAvatar: FC<{
  user: NavbarLoginUser;
  theming: NavbarLoginWidgetTheming;
}> = ({ user, theming }) => {
  if (user.avatarUrl) {
    return <NavbarLoginAvatarWrapper url={user.avatarUrl} theming={theming}/>;
  }
  return (
    <NavbarLoginAvatarWrapper theming={theming}>
      <NavbarLoginAvatarText>{user.letters}</NavbarLoginAvatarText>
    </NavbarLoginAvatarWrapper>
  );
};

export const LinkWrapper: FC<{ link?: LinkObject, children?: ReactNode }> = ({ link, children }) => {
  if (!link) {
    return <>{children}</>
  }

  if (link.external) {
    return <a href={link.path}>{children}</a>
  }

  return (
    <NeutralLink to={link.path}>
      {children}
    </NeutralLink>)
}

export const NavbarLoginWidget: FC<NavbarLoginWidgetProps> = (props) => {
  const { i18n } = useTranslation();
  const isGeo = AppTester.isGeograffee();

  if (!props.user) {
    return (
      <NavbarLoginWidgetOutter>
        <LoginButton onClick={props.loginAction} {...props.theming} lang={i18n.language}>
          {props.loginButtonText}
        </LoginButton>
      </NavbarLoginWidgetOutter>
    );
  } else {

    return (
      <NavbarLoginWidgetOutter>
        <Dropdown
          offsetY={18}
          offsetX={0}
          offsetArrowX={40}
          dark={isGeo}
          hideArrow
          orientation='right'
          target={<NavbarProfileAvatar user={props.user} theming={props.theming}/>}
        >
          {props.dropdown.map(({ title, action, link, hide }, i) => {
            if (hide) return false;
            
            return (
              (
                <LinkWrapper link={link} key={title}>
                  <DropdownListItem key={i} onClick={action}>
                    {title.toLowerCase()}
                  </DropdownListItem>
                </LinkWrapper>
              )
            )
          })}
        </Dropdown>
      </NavbarLoginWidgetOutter>
    );
  }
};
import { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { FlexBox, Dropdown, DropdownListItem, Fonts } from '@brg/ui';
import { LayoutConst } from 'core';
import { useTranslation } from 'react-i18next';
import { NeutralLink } from 'shared/components/link/styles';
import { AppTester } from 'supporting';

export interface NavbarLoginWidgetTheming {
  loginButtonColor: string;
  loginButtonHoverColor: string;

  noAvatarBackgroundColor: string;
  noAvatarTextColor: string;

  lang?: string;
}

export const LoginButton = styled(FlexBox)<NavbarLoginWidgetTheming>`
  ${Fonts.Inter.textBold};
  color: ${(p: NavbarLoginWidgetTheming) => p.loginButtonColor};
  transition: all 0.2s;
  align-items: center;
  font-size: 17px !important;
  cursor: pointer;
  line-height: 22px;
  font-weight: 600 !important;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px !important;
    line-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.m_1024}px) {
    font-size: 13px !important;
    line-height: 18px;
  }

  &:hover {
    color: ${(p: NavbarLoginWidgetTheming) => p.loginButtonHoverColor};
  }
`;

export const NavbarLoginWidgetOutter = styled(FlexBox)`
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const NavbarLoginAvatarWrapper = styled(FlexBox)<{
  theming: NavbarLoginWidgetTheming;
  url?: string;
}>`
  width: 32px;
  height: 32px;
  justify-items: center;
  align-items: center;
  text-align: center;
  border-radius: 3px;

  background-color: ${(p) => p.theming.noAvatarBackgroundColor};
  color: ${(p) => p.theming.noAvatarTextColor};
  ${(p: any) =>
          p.url
                  ? css`
                    background-image: url('${p.url}') !important;
                    background-position: center center;
                    background-size: cover;
                  `
                  : null};
  @media (max-width: 940px) {
    width: 32px;
    height: 32px;
  }
`;
export const NavbarLoginAvatarText = styled.div`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  width: 100%;
  font-size: 14px;

  @media (max-width: ${LayoutConst.screen.l_16}px){
    font-size: 0.7vw;
  }

  // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  //   font-size: 1vw;
  // }
`;

export const NavbarLoginChangeWrapper = styled(FlexBox)`
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(p) => p.theme.navigationBar.profile.bg};
  flex-direction: column;
`;

export const NavbarLoginChangeFrame = styled(FlexBox)`
  height: 272px;
  overflow-y: auto;
  margin-top: 28px;
  flex-direction: column;
  width: 574px;
`;

export const NavbarLoginChangeRow = styled(FlexBox)`
  cursor: pointer;

  :hover {
    opacity: 0.6;
  }
`;

export interface NavbarLoginUser {
  letters: string;
  avatarUrl?: string;
  profileId?: string;
  name?: string;
}

interface LinkObject {
  path?: string;
  external?: boolean;
}

export interface LoginDropdownItem {
  title: string,
  action?: () => void;
  link?: LinkObject;
  hide?: boolean;
}

export interface NavbarLoginWidgetProps {
  theming: NavbarLoginWidgetTheming;
  user?: NavbarLoginUser;
  loginAction?: () => void;
  logoutAction?: () => void;
  loginButtonText: string;
  dropdown: LoginDropdownItem[];
  className?: any;
}

export const NavbarProfileAvatar: FC<{
  user: NavbarLoginUser;
  theming: NavbarLoginWidgetTheming;
}> = ({ user, theming }) => {
  if (user.avatarUrl) {
    return <NavbarLoginAvatarWrapper url={user.avatarUrl} theming={theming}/>;
  }
  return (
    <NavbarLoginAvatarWrapper theming={theming}>
      <NavbarLoginAvatarText>{user.letters}</NavbarLoginAvatarText>
    </NavbarLoginAvatarWrapper>
  );
};

export const LinkWrapper: FC<{ link?: LinkObject, children?: ReactNode }> = ({ link, children }) => {
  if (!link) {
    return <>{children}</>
  }

  if (link.external) {
    return <a href={link.path}>{children}</a>
  }

  return (
    <NeutralLink to={link.path}>
      {children}
    </NeutralLink>)
}

export const NavbarLoginWidget: FC<NavbarLoginWidgetProps> = (props) => {
  const { i18n } = useTranslation();
  const isGeo = AppTester.isGeograffee();

  if (!props.user) {
    return (
      <NavbarLoginWidgetOutter>
        <LoginButton onClick={props.loginAction} {...props.theming} lang={i18n.language}>
          {props.loginButtonText}
        </LoginButton>
      </NavbarLoginWidgetOutter>
    );
  } else {

    return (
      <NavbarLoginWidgetOutter>
        <Dropdown
          offsetY={18}
          offsetX={0}
          offsetArrowX={40}
          dark={isGeo}
          hideArrow
          orientation='right'
          target={<NavbarProfileAvatar user={props.user} theming={props.theming}/>}
        >
          {props.dropdown.map(({ title, action, link, hide }, i) => {
            if (hide) return false;
            
            return (
              (
                <LinkWrapper link={link} key={title}>
                  <DropdownListItem key={i} onClick={action}>
                    {title.toLowerCase()}
                  </DropdownListItem>
                </LinkWrapper>
              )
            )
          })}
        </Dropdown>
      </NavbarLoginWidgetOutter>
    );
  }
};
